import { GlobalNotificationsAction, GlobalNotificationsActionTypes } from '@completion/actions';
import { GlobalNotification } from '@completion/models';

export interface GlobalNotificationsState {
  notifications: GlobalNotification[];
  loading: boolean;
  saving: boolean;
  error: unknown;
}

export const initialState: GlobalNotificationsState = {
  notifications: [],
  loading: false,
  saving: false,
  error: null,
};

export function globalNotificationsReducer(
  state: GlobalNotificationsState = initialState,
  action: GlobalNotificationsAction,
): GlobalNotificationsState {
  switch (action.type) {
    case GlobalNotificationsActionTypes.Load:
      return { ...state, loading: true, error: null };
    case GlobalNotificationsActionTypes.LoadSuccess:
      return { ...state, notifications: action.notifications, loading: false };
    case GlobalNotificationsActionTypes.LoadFail:
      return { ...state, loading: false, error: action.error };
    case GlobalNotificationsActionTypes.Create:
    case GlobalNotificationsActionTypes.Delete:
      return { ...state, saving: true, error: null };
    case GlobalNotificationsActionTypes.CreateSuccess:
      return { ...state, notifications: [action.notification, ...state.notifications], saving: false };
    case GlobalNotificationsActionTypes.DeleteSuccess:
      return { ...state, notifications: state.notifications.filter((notification) => notification.id !== action.id), saving: false };
    case GlobalNotificationsActionTypes.CreateFail:
    case GlobalNotificationsActionTypes.DeleteFail:
      return { ...state, saving: false, error: action.error };
    default:
      return state;
  }
}
